<template>
  <v-dialog
    v-model="enable"
    persistent
    max-width="580px"
  >
    <v-card>
      <v-container
        class="pa-0"
        fluid
      >
        <v-card-title class="headline">
          {{ alert.id ? 'Update' : 'Create' }} Alert
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-form
            id="form_register"
            ref="form"
            v-model="isValid"
            lazy-validation
          >
            <v-flex xs12>
              <v-text-field
                id="alert_title"
                ref="alert_name"
                v-model="alert.title"
                label="Alert Title*"
                type="text"
                autofocus
                required
              />
            </v-flex>
            <v-flex xs12>
              <v-textarea
                v-model="alert.description"
                label="Description"
                :hint="descriptionHint"
                persistent-hint
              />
            </v-flex>
            <v-flex xs12>
              <v-text-field
                id="skip_time"
                ref="skip_time"
                v-model="alert.skipTime"
                label="Skip Time (In Seconds)"
                type="number"
                autofocus
                required
                class="mt-3"
              />
            </v-flex>
            <v-flex xs12>
              <v-text-field
                id="refresh_time"
                ref="refresh_time"
                v-model="alert.refreshTime"
                label="Refresh Time (In Hours)"
                type="number"
                autofocus
                required
              />
            </v-flex>
            <v-flex>
              <v-menu
                v-model="datePicker"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formattedDate"
                    label="Deadline"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="date2"
                  :min="minDate"
                  @input="datePicker = false"
                />
              </v-menu>
            </v-flex>
          </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn
            v-if="alert.id"
            color="error"
            @click="deleteAlert(alert.id)"
          >
            Delete
          </v-btn>
          <v-btn
            v-if="alert.activeStatus && alert.id"
            color="warning"
            @click="changeStatus(false, alert.id)"
          >
            De-Activate
          </v-btn>
          <v-btn
            v-if="!alert.activeStatus && alert.id"
            color="success"
            @click="changeStatus(true, alert.id)"
          >
            Activate
          </v-btn>
          <v-spacer />
          <v-btn
            id="register_close"
            color="error"
            class="white--text"
            @click.native="close()"
          >
            Close
          </v-btn>
          <v-btn
            id="register_save"
            color="success"
            class="white--text"
            :disabled="!isValid"
            :loading="loader"
            @click="saveAlert()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { format } from "date-fns";

export default {
  name: "EditAlerts",
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    accountId: {
      type: Number,
      required: false,
      default: null
    },
    corporateId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      isValid: false,
      loader: false,
      accountNameRules: [
        (v) => !!v || "Account name is required",
        (v) =>
          (v && v.length <= 50) ||
          "AccountName must be less than 50 characters"
      ],
      descriptionHint:"Note: {{ days }} will be replaced with remaining days, {{ date }} will be replaced with deadline. ",
      alert: {
        skipTime: 1,
        refreshTime: 2,
        title: "",
        description: "",
        dLine: "",
        deadLine: format(new Date(), "dd-MMM-yyyy")
      },
      minDate: new Date().toISOString().substr(0, 10),
      datePicker: false,
      date2: new Date().toISOString().substr(0, 10),
      alertType: 0,
      typeId: 0
    };
  },
  computed: {
    enable: {
      get() {
        return this.showDialog;
      },
      set(val) {
        console.log({ val });
      }
    },
    formattedDate: {
      get() {
        let d = new Date(this.date2);
        return format(d, "dd-MMM-yyyy");
      },
      set(newValue) {
        console.log({ newValue });
        this.date2 = new Date(this.alert.dLine);
      }
    }
  },
  watch: {
    enable(v) {
      if (v) {
        this.fetchAlert();
      }
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.alertType = 1;
      this.typeId = this.accountId;
      this.alert.accountID = this.accountId;
      if (this.corporateId > 0) {
        this.alertType = 2;
        this.typeId = this.corporateId;
        this.alert.corporateId = this.corporateId;
      }
    },
    getError(key) {
      return this.errors && this.errors[key] ? [this.errors[key]] : [];
    },
    dirtyError(key) {
      this.errors[key] = "";
    },
    handleFailure: function (failure) {
      let msg = failure.body.message || "Error";
      let errors = failure.body.errors;
      if (errors && errors.Name) {
        msg = errors.Name;
      }
      this.$store.commit("showSnackbar", {
        message: msg,
        color: "error"
      });
    },
    clear() {
      this.errors = {};
      this.$refs.form.reset();
    },
    close() {
      this.$emit("update:showDialog", false);
      this.$emit("refresh");
      // this.clear();
    },
    handleSuccess(response) {
      this.$store.commit("showSnackbar", {
        timeout: 3000,
        message: response.message
      });
    },
    changeStatus(status, alertID) {
      let statusStr = "inActivate";
      if (status) {
        statusStr = "activate";
      }
      let message = "Are you sure you want to " + statusStr + " the alert?";

      this.$root.$confirm
        .open("Confirm", message, {})
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.$http
            .post(`${this.ADMIN_API_URL}/alerts/${alertID}/statusUpd`, {alertStatus: status})
            .then(
              (data) => {
                this.handleSuccess(data.body);
                this.close();
              },
              (failure) => {
                this.handleFailure(failure);
              }
            );
        });
    },
    deleteAlert(alertID) {
      this.$root.$confirm
        .open("Confirm", "Are you sure you want to delete the alert?", {})
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.$http
            .post(`${this.ADMIN_API_URL}/alerts/${alertID}/remove`)
            .then(
              (data) => {
                this.handleSuccess(data.body);
                this.close();
              },
              (failure) => {
                this.handleFailure(failure);
              }
            );
        });
    },
    fetchAlert() {
      this.loader = true;
      this.$http
        .post(
          `${this.ADMIN_API_URL}/fetchAlert?alertType=${this.alertType}&typeId=${this.typeId}`
        )
        .then(
          function (resp) {
            console.log({ resp });
            this.alert = resp.body || {};
            console.log(
              "DATE ",
              format(new Date(this.alert.dLine), "yyyy-MM-dd")
            );
            this.date2 = format(new Date(this.alert.dLine), "yyyy-MM-dd");
            this.loader = false;
          },
          function (failure) {
            console.log({ failure });
            this.loader = false;
          }
        );
    },
    saveAlert() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.alert.dLine = this.formattedDate;
      this.alert.skipTime = parseInt(this.alert.skipTime);
      this.alert.refreshTime = parseInt(this.alert.refreshTime);
      this.alert.deadLine = null;

      this.loader = true;
      this.$http.post(`${this.ADMIN_API_URL}/alerts`, this.alert).then(
        function (data) {
          this.loader = false;
          this.close();
          this.$store.commit("showSnackbar", {
            timeout: 3000,
            message: data.body.message
          });
        },
        function (failure) {
          this.loader = false;
          this.handleFailure(failure);
        }
      );
    }
  }
};
</script>